import React, { Component } from "react";
import { connect } from "react-redux";
import {
  searchDraft,
  deleteDraftSkill,
  changeActiveTab,
  searchSkillsByTemplate
} from "../../../../redux/actions/skill";
import { withRouter } from "react-router";
import { compose } from "redux";
import DraftItem from "./MyDraftItem";
import EmptyLoader from "../../../../components/emptyLoader";
import getColors from "../../../../components/colors"
import Loader from "../../../../components/loader";
import { notify } from "../../../../redux/actions/snack";
import backArrow from "../../../../images/back-arrow.png";
import { Pagination } from "antd";

class SearchResults extends Component {
  constructor() {
    super();
    this.state = {
      skills: [],
      filteredSkills: [],
      skillPageInfo: null,
      pageSize: 10,
      hasMore: true,
      searchItem: null,
      isSearching: true,
      activeSearch: "",
      isScrolling: false,
      activePage: 1,
      itemsPerPage: 9,
      publishedPage: 1,
      draftPage: 1,
      pendingPage: 1,
      userPage: 1,
      inAppPage: 1,
      blankPage: 1,
      importPage: 1,
      webAutoPage: 1,
      desktopPage: 1,
      userDocPage: 1,
      userOnPage: 1
    };
  }

  openConfigure = (item) => {
    this.props.addSkillToUser(item);
  };

  // componentDidMount() {
  //   const { searchQuery } = this.props?.skillReducer;
  //   const template = this.props?.skillReducer?.selectedTemplate
  //   if (searchQuery !== undefined) {
  //     this.getSearchResults(searchQuery);
  //   } 
  //   else if (template === "In-App Walkthrough" || template === "Blank Template" 
  //   || template === "UserDocumentation" || template === "WebAutomation" 
  //   || template === "Import Data from Spreadsheet to Web App" || template === "Desktop Walkthrough"
  //   || template === "UserOnboarding"
  //   ) {
  //     this.getFilteredSearchResults();
  //   } 
  //   else {
  //     this.getSearchResults();
  //   }
  // }

  componentDidMount() {
    const { searchQuery } = this.props?.skillReducer;
    const template = this.props?.skillReducer?.selectedTemplate;
    const filter = this.props?.skillReducer?.selectedFilter
    
    if ( 
      template === "In-App Walkthrough" ||
      template === "Blank Template" ||
      template === "UserDocumentation" ||
      template === "WebAutomation" ||
      template === "Import Data from Spreadsheet to Web App" ||
      template === "Desktop Walkthrough" ||
      template === "UserOnboarding"
    ) {
      this.getFilteredSearchResults(searchQuery);
    } else {
      this.getSearchResults(searchQuery);
  }
}
 
  componentDidUpdate(prevProps, prevState) {

    const { activePage, publishedPage, draftPage, pendingPage,
      userPage, otherUserPage, inAppPage, importPage,
      blankPage, webAutoPage, userDocPage, userOnPage,
      desktopPage
    } = this.state;
    if (activePage !== prevState.activePage ||
      publishedPage !== prevState.publishedPage ||
      draftPage !== prevState.draftPage ||
      pendingPage !== prevState.pendingPage ||
      userPage !== prevState.userPage ||
      otherUserPage !== prevState.otherUserPage
    ) {
      const { searchQuery } = this.props?.skillReducer;
      if (searchQuery !== undefined) {
        this.getSearchResults(searchQuery);
      }
    }
    else if (
      inAppPage !== prevState.inAppPage ||
      blankPage !== prevState.blankPage ||
      userDocPage !== prevState.userDocPage ||
      userOnPage !== prevState.userOnPage ||
      webAutoPage !== prevState.webAutoPage ||
      importPage !== prevState.importPage ||
      desktopPage !== prevState.desktopPage
    ) {
      this.getFilteredSearchResults();
    }
  }

  handlePageChange = (pageNumber) => {
    this.setState({ activePage: pageNumber, isSearching: true });
    const queryParams = new URLSearchParams(window.location.search);
    queryParams.set('page', pageNumber);
    window.history.replaceState({}, '', `${window.location.pathname}?${queryParams.toString()}`);
    const { searchQuery } = this.props?.skillReducer;
    if (searchQuery !== undefined) {
      this.getSearchResults(searchQuery);
    }
  };

  handlePublishedPageChange = (pageNumber) => {
    this.setState({ publishedPage: pageNumber, isSearching: true });
    const queryParams = new URLSearchParams(window.location.search);
    queryParams.set('page', pageNumber);
    window.history.replaceState({}, '', `${window.location.pathname}?${queryParams.toString()}`);
    const { searchQuery } = this.props?.skillReducer;
    if (searchQuery !== undefined) {
      this.getSearchResults(searchQuery);
    }
  };

  handleDraftPageChange = (pageNumber) => {
    let email = this.props?.skillReducer?.userEmail;
    this.setState({ draftPage: pageNumber, isSearching: true });
    const queryParams = new URLSearchParams(window.location.search);
    queryParams.set('page', pageNumber);
    window.history.replaceState({}, '', `${window.location.pathname}?${queryParams.toString()}`);
    const { searchQuery } = this.props?.skillReducer;
    if (searchQuery !== undefined) {
      this.getSearchResults(searchQuery);
    }
  };

  handlePendingPageChange = (pageNumber) => {
    this.setState({ pendingPage: pageNumber, isSearching: true });
    const queryParams = new URLSearchParams(window.location.search);
    queryParams.set('page', pageNumber);
    window.history.replaceState({}, '', `${window.location.pathname}?${queryParams.toString()}`);
    const { searchQuery } = this.props?.skillReducer;
    if (searchQuery !== undefined) {
      this.getSearchResults(searchQuery);
    }
  };

  handleUserPageChange = (pageNumber) => {
    let email = this.props?.skillReducer?.userEmail;
    this.setState({ userPage: pageNumber, isLoading: true });
    const queryParams = new URLSearchParams(window.location.search);
    queryParams.set('page', pageNumber);
    window.history.replaceState({}, '', `${window.location.pathname}?${queryParams.toString()}`);
    const { searchQuery } = this.props?.skillReducer;
    if (searchQuery !== undefined) {
      this.getSearchResults(searchQuery);
    }
  };

  handleOtherUserPageChange = (pageNumber) => {
    let email = this.props?.skillReducer?.userEmail;
    this.setState({ otherUserPage: pageNumber, isLoading: true });
    const queryParams = new URLSearchParams(window.location.search);
    queryParams.set('page', pageNumber);
    window.history.replaceState({}, '', `${window.location.pathname}?${queryParams.toString()}`);
    const { searchQuery } = this.props?.skillReducer;
    if (searchQuery !== undefined) {
      this.getSearchResults(searchQuery);
    }
  };

  handleInAppPageChange = (pageNumber) => {
    this.setState({ inAppPage: pageNumber, isLoading: true });
    const queryParams = new URLSearchParams(window.location.search);
    queryParams.set('page', pageNumber);
    window.history.replaceState({}, '', `${window.location.pathname}?${queryParams.toString()}`);
    const { searchQuery } = this.props?.skillReducer;
    if (searchQuery !== undefined) {
      this.getFilteredSearchResults(searchQuery);
    }
  };

  handleBlankPageChange = (pageNumber) => {
    this.setState({ blankPage: pageNumber, isLoading: true });
    const queryParams = new URLSearchParams(window.location.search);
    queryParams.set('page', pageNumber);
    window.history.replaceState({}, '', `${window.location.pathname}?${queryParams.toString()}`);
    const { searchQuery } = this.props?.skillReducer;
    if (searchQuery !== undefined) {
      this.getFilteredSearchResults(searchQuery);
    }
  };
 
  handleDesktopPageChange = (pageNumber) => {
    this.setState({ desktopPage: pageNumber, isLoading: true });
    const queryParams = new URLSearchParams(window.location.search);
    queryParams.set('page', pageNumber);
    window.history.replaceState({}, '', `${window.location.pathname}?${queryParams.toString()}`);
    const { searchQuery } = this.props?.skillReducer;
    if (searchQuery !== undefined) {
      this.getFilteredSearchResults(searchQuery);
    }
  };

  handleUserDocPageChange = (pageNumber) => {
    this.setState({ userDocPage: pageNumber, isLoading: true });
    const queryParams = new URLSearchParams(window.location.search);
    queryParams.set('page', pageNumber);
    window.history.replaceState({}, '', `${window.location.pathname}?${queryParams.toString()}`);
    const { searchQuery } = this.props?.skillReducer;
    if (searchQuery !== undefined) {
      this.getFilteredSearchResults(searchQuery);
    }
  };

  handleUserOnPageChange = (pageNumber) => {
    this.setState({ userOnPage: pageNumber, isLoading: true });
    const queryParams = new URLSearchParams(window.location.search);
    queryParams.set('page', pageNumber);
    window.history.replaceState({}, '', `${window.location.pathname}?${queryParams.toString()}`);
    const { searchQuery } = this.props?.skillReducer;
    if (searchQuery !== undefined) {
      this.getFilteredSearchResults(searchQuery);
    }
  };

  handleWebAutoPageChange = (pageNumber) => {
    this.setState({ webAutoPage: pageNumber, isLoading: true });
    const queryParams = new URLSearchParams(window.location.search);
    queryParams.set('page', pageNumber);
    window.history.replaceState({}, '', `${window.location.pathname}?${queryParams.toString()}`);
    const { searchQuery } = this.props?.skillReducer;
    if (searchQuery !== undefined) {
      this.getFilteredSearchResults(searchQuery);
    }
  };

  handleImportPageChange = (pageNumber) => {
    this.setState({ importPage: pageNumber, isLoading: true });
    const queryParams = new URLSearchParams(window.location.search);
    queryParams.set('page', pageNumber);
    window.history.replaceState({}, '', `${window.location.pathname}?${queryParams.toString()}`);
    const { searchQuery } = this.props?.skillReducer;
    if (searchQuery !== undefined) {
      this.getFilteredSearchResults(searchQuery);
    }
  };

  getSearchResults = async (query) => {
    if (query === undefined) {
      query = this.props?.match?.params?.id.split("=")[1];
    }
    var skillType = this.props.match.params.id.split("?")[0];
    let email;
    let template = this.props?.skillReducer?.selectedTemplate
    let filter = this.props?.skillReducer?.selectedFilter;
    if (filter === 'CreatedBy Me') {
      email = this.props?.userReducer?.user?.email;
    } else {
      email = this.props?.skillReducer?.userEmail;
    }
    const queryParams = new URLSearchParams(window.location.search);
    let page = parseInt(queryParams.get('page')) || 1;
    let data = { query, filter, page, email, template }
    const searchResults = await this.props.searchDraft(data);
    if (searchResults) {
      if (searchResults.results.length) {
        this.setState({
          isSearching: false,
          skills: searchResults.results,
          skillPageInfo: searchResults.pageInfo,
          isScrolling: false,
        });
      } else {
        this.setState({
          isSearching: false,
          hasMore: false,
          isScrolling: false,
        });
      }
    } else {
      this.setState({
        isSearching: false,
        hasMore: false,
        isScrolling: false,
      });
    }
  };

  getFilteredSearchResults = async (query) => {
    if (query === undefined) {
      query = this.props?.match?.params?.id.split("=")[1];
    }
    let template = this.props?.skillReducer?.selectedTemplate
    const queryParams = new URLSearchParams(window.location.search);
    let page = parseInt(queryParams.get('page')) || 1;
    let data = { query, page, template }
    const searchResults = await this.props.searchSkillsByTemplate(data);
    if (searchResults) {
      if (searchResults.results.length) {
        this.setState({
          isSearching: false,
          filteredSkills: searchResults.results,
          skillPageInfo: searchResults.pageInfo,
          isScrolling: false,
        });
      } else {
        this.setState({
          isSearching: false,
          hasMore: false,
          isScrolling: false,
        });
      }
    } else {
      this.setState({
        isSearching: false,
        hasMore: false,
        isScrolling: false,
      });
    }
  };

  backtoggle() {
    this.props.history.goBack();
    this.props.changeActiveTab("All")
  }

  render() {
    const { isActive } = this.props?.skillReducer?.selectedFilter;
    const template = this.props?.skillReducer?.selectedTemplate
    const queryParams = new URLSearchParams(window.location.search);
    const AllPage = parseInt(queryParams.get('page')) || 1;
    const publishedPage = parseInt(queryParams.get('page')) || 1;
    const draftPage = parseInt(queryParams.get('page')) || 1;
    const pendingPage = parseInt(queryParams.get('page')) || 1;
    const userPage = parseInt(queryParams.get('page')) || 1;
    const otherUserPage = parseInt(queryParams.get('page')) || 1;
    const inAppPage = parseInt(queryParams.get('page')) || 1;
    const blankPage = parseInt(queryParams.get('page')) || 1;
    const webAutoPage = parseInt(queryParams.get('page')) || 1;
    const importPage = parseInt(queryParams.get('page')) || 1;
    const userOnPage = parseInt(queryParams.get('page')) || 1;
    const userDocPage = parseInt(queryParams.get('page')) || 1;
    const desktopPage = parseInt(queryParams.get('page')) || 1;
    return (
      <React.Fragment>
        <div className="store-search-page">
          <div class="knb-title">
            <div class="back-title">
              <button
                class="back-qa"
                onClick={() => {
                  this.backtoggle();
                }}
              >
                <img src={backArrow} alt={backArrow} />
              </button>
            </div>
            <p class="kn-title" style={{ flex: 1 }}>
              Back to Search
            </p>
            <div class="btn-right"></div>
          </div>
          {isActive === "published" ? (
            <div className="task-col">
            <div className="title-btn">
              <h1 className="title">Search Results</h1>
            </div>
            <div id="scrollableDiv" className="scrollable tl-scroll">
              {this.state.isSearching ? (
                <div class="empty-view">
                  <Loader
                    styles={{ width: "80px", margin: "auto" }}
                    root={{ display: "flex" }}
                  />
                </div>
              ) : (
                <div>
                  {this.state.isSearching && !this.state.skills.length ? (
                    <div>
                      <EmptyLoader
                        style={{ width: "30%" }}
                        message="No Result found"
                      />
                      <p style={{ textAlign: "center" }}>No Result found</p>
                    </div>
                  ) : (
                    <>
                      <div id="scrollableDiv" className="scrollable tl-scroll">
                        {this.state.isSearching ? (
                          <Loader
                            styles={{ width: "80px", margin: "auto" }}
                            root={{ display: "flex" }}
                          />
                        ) : (
                          <div>
                            {this.state.isSearching === false && !this.state.skills.length ? (
                              <div>
                                <EmptyLoader
                                  style={{ width: "30%" }}
                                  message="No Results found"
                                />
                              </div>
                            ) : (
                              <div>
                                {this.state.skills
                                  .map((item, key) => (
                                    <DraftItem
                                      color={getColors(item.SKILL_NAME)}
                                      key={key}
                                      skill={item}
                                      {...this.props}
                                      deleteDraftSkill={this.deleteDraftSkill}
                                    />
                                  ))}
                                <div className="template-flex">
                                  <div className="template-box scrollable">
                                    <Pagination
                                      current={publishedPage}
                                      pageSize={9}
                                      total={this.props.searchCount}
                                      onChange={this.handlePublishedPageChange}
                                      hideOnSinglePage={false}
                                      showSizeChanger={false}
                                    />
                                  </div>
                                </div>
                              </div>
                            )}
                          </div>
                        )}
                      </div>
                    </>
                  )}
                </div>
              )}
            </div>
          </div> ) : isActive === "draft" ? (
            <div className="task-col">
            <div className="title-btn">
              <h1 className="title">Search Results</h1>
            </div>
            <div id="scrollableDiv" className="scrollable tl-scroll">
              {this.state.isSearching ? (
                <div class="empty-view">
                  <Loader
                    styles={{ width: "80px", margin: "auto" }}
                    root={{ display: "flex" }}
                  />
                </div>
              ) : (
                <div>
                  {this.state.isSearching && !this.state.skills.length ? (
                    <div>
                      <EmptyLoader
                        style={{ width: "30%" }}
                        message="No Result found"
                      />
                      <p style={{ textAlign: "center" }}>No Result found</p>
                    </div>
                  ) : (
                    <>
                      <div id="scrollableDiv" className="scrollable tl-scroll">
                        {this.state.isSearching ? (
                          <Loader
                            styles={{ width: "80px", margin: "auto" }}
                            root={{ display: "flex" }}
                          />
                        ) : (
                          <div>
                            {this.state.isSearching === false && !this.state.skills.length ? (
                              <div>
                                <EmptyLoader
                                  style={{ width: "30%" }}
                                  message="No Results found"
                                />
                              </div>
                            ) : (
                              <div>
                                {this.state.skills
                                  .map((item, key) => (
                                    <DraftItem
                                      color={getColors(item.SKILL_NAME)}
                                      key={key}
                                      skill={item}
                                      {...this.props}
                                      deleteDraftSkill={this.deleteDraftSkill}
                                    />
                                  ))}
                                <div className="template-flex">
                                  <div className="template-box scrollable">
                                    <Pagination
                                      current={draftPage}
                                      pageSize={9}
                                      total={this.props.searchCount}
                                      onChange={this.handleDraftPageChange}
                                      hideOnSinglePage={false}
                                      showSizeChanger={false}
                                    />
                                  </div>
                                </div>
                              </div>
                            )}
                          </div>
                        )}
                      </div>
                    </>
                  )}
                </div>
              )}
            </div>
          </div> ) : isActive === "CreatedBy" ? (
            <div className="task-col">
            <div className="title-btn">
              <h1 className="title">Search Results</h1>
            </div>
            <div id="scrollableDiv" className="scrollable tl-scroll">
              {this.state.isSearching ? (
                <div class="empty-view">
                  <Loader
                    styles={{ width: "80px", margin: "auto" }}
                    root={{ display: "flex" }}
                  />
                </div>
              ) : (
                <div>
                  {this.state.isSearching && !this.state.skills.length ? (
                    <div>
                      <EmptyLoader
                        style={{ width: "30%" }}
                        message="No Result found"
                      />
                      <p style={{ textAlign: "center" }}>No Result found</p>
                    </div>
                  ) : (
                    <>
                      <div id="scrollableDiv" className="scrollable tl-scroll">
                        {this.state.isSearching ? (
                          <Loader
                            styles={{ width: "80px", margin: "auto" }}
                            root={{ display: "flex" }}
                          />
                        ) : (
                          <div>
                            {this.state.isSearching === false && !this.state.skills.length ? (
                              <div>
                                <EmptyLoader
                                  style={{ width: "30%" }}
                                  message="No Results found"
                                />
                              </div>
                            ) : (
                              <div>
                                {this.state.skills
                                  .map((item, key) => (
                                    <DraftItem
                                      color={getColors(item.SKILL_NAME)}
                                      key={key}
                                      skill={item}
                                      {...this.props}
                                      deleteDraftSkill={this.deleteDraftSkill}
                                    />
                                  ))}
                                <div className="template-flex">
                                  <div className="template-box scrollable">
                                    <Pagination
                                      current={otherUserPage}
                                      pageSize={9}
                                      total={this.props.searchCount}
                                      onChange={this.handleOtherUserPageChange}
                                      hideOnSinglePage={false}
                                      showSizeChanger={false}
                                    />
                                  </div>
                                </div>
                              </div>
                            )}
                          </div>
                        )}
                      </div>
                    </>
                  )}
                </div>
              )}
            </div>
          </div> ) : isActive === "pending" ? (
            <div className="task-col">
            <div className="title-btn">
              <h1 className="title">Search Results</h1>
            </div>
            <div id="scrollableDiv" className="scrollable tl-scroll">
              {this.state.isSearching ? (
                <div class="empty-view">
                  <Loader
                    styles={{ width: "80px", margin: "auto" }}
                    root={{ display: "flex" }}
                  />
                </div>
              ) : (
                <div>
                  {this.state.isSearching && !this.state.skills.length ? (
                    <div>
                      <EmptyLoader
                        style={{ width: "30%" }}
                        message="No Result found"
                      />
                      <p style={{ textAlign: "center" }}>No Result found</p>
                    </div>
                  ) : (
                    <>
                      <div id="scrollableDiv" className="scrollable tl-scroll">
                        {this.state.isSearching ? (
                          <Loader
                            styles={{ width: "80px", margin: "auto" }}
                            root={{ display: "flex" }}
                          />
                        ) : (
                          <div>
                            {this.state.isSearching === false && !this.state.skills.length ? (
                              <div>
                                <EmptyLoader
                                  style={{ width: "30%" }}
                                  message="No Results found"
                                />
                              </div>
                            ) : (
                              <div>
                                {this.state.skills
                                  .map((item, key) => (
                                    <DraftItem
                                      color={getColors(item.SKILL_NAME)}
                                      key={key}
                                      skill={item}
                                      {...this.props}
                                      deleteDraftSkill={this.deleteDraftSkill}
                                    />
                                  ))}
                                <div className="template-flex">
                                  <div className="template-box scrollable">
                                    <Pagination
                                      current={pendingPage}
                                      pageSize={9}
                                      total={this.props.searchCount}
                                      onChange={this.handlePendingPageChange}
                                      hideOnSinglePage={false}
                                      showSizeChanger={false}
                                    />
                                  </div>
                                </div>
                              </div>
                            )}
                          </div>
                        )}
                      </div>
                    </>
                  )}
                </div>
              )}
            </div>
          </div> ) : template === "In-App Walkthrough" ? (
            <div className="task-col">
            <div className="title-btn">
              <h1 className="title">Search Results</h1>
            </div>
            <div id="scrollableDiv" className="scrollable tl-scroll">
              {this.state.isSearching ? (
                <div class="empty-view">
                  <Loader
                    styles={{ width: "80px", margin: "auto" }}
                    root={{ display: "flex" }}
                  />
                </div>
              ) : (
                <div>
                  {this.state.isSearching && !this.state.filteredSkills.length ? (
                    <div>
                      <EmptyLoader
                        style={{ width: "30%" }}
                        message="No Result found"
                      />
                      <p style={{ textAlign: "center" }}>No Result found</p>
                    </div>
                  ) : (
                    <>
                      <div id="scrollableDiv" className="scrollable tl-scroll">
                        {this.state.isSearching ? (
                          <Loader
                            styles={{ width: "80px", margin: "auto" }}
                            root={{ display: "flex" }}
                          />
                        ) : (
                          <div>
                            {this.state.isSearching === false && !this.state.filteredSkills.length ? (
                              <div>
                                <EmptyLoader
                                  style={{ width: "30%" }}
                                  message="No Results found"
                                />
                              </div>
                            ) : (
                              <div>
                                {this.state.filteredSkills
                                  .map((item, key) => (
                                    <DraftItem
                                      color={getColors(item.SKILL_NAME)}
                                      key={key}
                                      skill={item}
                                      {...this.props}
                                      deleteDraftSkill={this.deleteDraftSkill}
                                    />
                                  ))}
                                <div className="template-flex">
                                  <div className="template-box scrollable">
                                    <Pagination
                                      current={inAppPage}
                                      pageSize={9}
                                      total={this.props.searchFilteredCount}
                                      onChange={this.handleInAppPageChange}
                                      hideOnSinglePage={false}
                                      showSizeChanger={false}
                                    />
                                  </div>
                                </div>
                              </div>
                            )}
                          </div>
                        )}
                      </div>
                    </>
                  )}
                </div>
              )}
            </div>
          </div> ) : template === "Blank Template" ? (
            <div className="task-col">
            <div className="title-btn">
              <h1 className="title">Search Results</h1>
            </div>
            <div id="scrollableDiv" className="scrollable tl-scroll">
              {this.state.isSearching ? (
                <div class="empty-view">
                  <Loader
                    styles={{ width: "80px", margin: "auto" }}
                    root={{ display: "flex" }}
                  />
                </div>
              ) : (
                <div>
                  {this.state.isSearching && !this.state.filteredSkills.length ? (
                    <div>
                      <EmptyLoader
                        style={{ width: "30%" }}
                        message="No Result found"
                      />
                      <p style={{ textAlign: "center" }}>No Result found</p>
                    </div>
                  ) : (
                    <>
                      <div id="scrollableDiv" className="scrollable tl-scroll">
                        {this.state.isSearching ? (
                          <Loader
                            styles={{ width: "80px", margin: "auto" }}
                            root={{ display: "flex" }}
                          />
                        ) : (
                          <div>
                            {this.state.isSearching === false && !this.state.filteredSkills.length ? (
                              <div>
                                <EmptyLoader
                                  style={{ width: "30%" }}
                                  message="No Results found"
                                />
                              </div>
                            ) : (
                              <div>
                                {this.state.filteredSkills
                                  .map((item, key) => (
                                    <DraftItem
                                      color={getColors(item.SKILL_NAME)}
                                      key={key}
                                      skill={item}
                                      {...this.props}
                                      deleteDraftSkill={this.deleteDraftSkill}
                                    />
                                  ))}
                                <div className="template-flex">
                                  <div className="template-box scrollable">
                                    <Pagination
                                      current={blankPage}
                                      pageSize={9}
                                      total={this.props.searchFilteredCount}
                                      onChange={this.handleBlankPageChange}
                                      hideOnSinglePage={false}
                                      showSizeChanger={false}
                                    />
                                  </div>
                                </div>
                              </div>
                            )}
                          </div>
                        )}
                      </div>
                    </>
                  )}
                </div>
              )}
            </div>
          </div> ) : template === "UserDocumentation" ? (
            <div className="task-col">
            <div className="title-btn">
              <h1 className="title">Search Results</h1>
            </div>
            <div id="scrollableDiv" className="scrollable tl-scroll">
              {this.state.isSearching ? (
                <div class="empty-view">
                  <Loader
                    styles={{ width: "80px", margin: "auto" }}
                    root={{ display: "flex" }}
                  />
                </div>
              ) : (
                <div>
                  {this.state.isSearching && !this.state.filteredSkills.length ? (
                    <div>
                      <EmptyLoader
                        style={{ width: "30%" }}
                        message="No Result found"
                      />
                      <p style={{ textAlign: "center" }}>No Result found</p>
                    </div>
                  ) : (
                    <>
                      <div id="scrollableDiv" className="scrollable tl-scroll">
                        {this.state.isSearching ? (
                          <Loader
                            styles={{ width: "80px", margin: "auto" }}
                            root={{ display: "flex" }}
                          />
                        ) : (
                          <div>
                            {this.state.isSearching === false && !this.state.filteredSkills.length ? (
                              <div>
                                <EmptyLoader
                                  style={{ width: "30%" }}
                                  message="No Results found"
                                />
                              </div>
                            ) : (
                              <div>
                                {this.state.filteredSkills
                                  .map((item, key) => (
                                    <DraftItem
                                      color={getColors(item.SKILL_NAME)}
                                      key={key}
                                      skill={item}
                                      {...this.props}
                                      deleteDraftSkill={this.deleteDraftSkill}
                                    />
                                  ))}
                                <div className="template-flex">
                                  <div className="template-box scrollable">
                                    <Pagination
                                      current={userDocPage}
                                      pageSize={9}
                                      total={this.props.searchFilteredCount}
                                      onChange={this.handleUserDocPageChange}
                                      hideOnSinglePage={false}
                                      showSizeChanger={false}
                                    />
                                  </div>
                                </div>
                              </div>
                            )}
                          </div>
                        )}
                      </div>
                    </>
                  )}
                </div>
              )}
            </div>
          </div> ) : template === "WebAutomation" ? (
            <div className="task-col">
            <div className="title-btn">
              <h1 className="title">Search Results</h1>
            </div>
            <div id="scrollableDiv" className="scrollable tl-scroll">
              {this.state.isSearching ? (
                <div class="empty-view">
                  <Loader
                    styles={{ width: "80px", margin: "auto" }}
                    root={{ display: "flex" }}
                  />
                </div>
              ) : (
                <div>
                  {this.state.isSearching && !this.state.filteredSkills.length ? (
                    <div>
                      <EmptyLoader
                        style={{ width: "30%" }}
                        message="No Result found"
                      />
                      <p style={{ textAlign: "center" }}>No Result found</p>
                    </div>
                  ) : (
                    <>
                      <div id="scrollableDiv" className="scrollable tl-scroll">
                        {this.state.isSearching ? (
                          <Loader
                            styles={{ width: "80px", margin: "auto" }}
                            root={{ display: "flex" }}
                          />
                        ) : (
                          <div>
                            {this.state.isSearching === false && !this.state.filteredSkills.length ? (
                              <div>
                                <EmptyLoader
                                  style={{ width: "30%" }}
                                  message="No Results found"
                                />
                              </div>
                            ) : (
                              <div>
                                {this.state.filteredSkills
                                  .map((item, key) => (
                                    <DraftItem
                                      color={getColors(item.SKILL_NAME)}
                                      key={key}
                                      skill={item}
                                      {...this.props}
                                      deleteDraftSkill={this.deleteDraftSkill}
                                    />
                                  ))}
                                <div className="template-flex">
                                  <div className="template-box scrollable">
                                    <Pagination
                                      current={webAutoPage}
                                      pageSize={9}
                                      total={this.props.searchFilteredCount}
                                      onChange={this.handleWebAutoPageChange}
                                      hideOnSinglePage={false}
                                      showSizeChanger={false}
                                    />
                                  </div>
                                </div>
                              </div>
                            )}
                          </div>
                        )}
                      </div>
                    </>
                  )}
                </div>
              )}
            </div>
          </div> ) : template === "Import Data from Spreadsheet to Web App" ? (
            <div className="task-col">
            <div className="title-btn">
              <h1 className="title">Search Results</h1>
            </div>
            <div id="scrollableDiv" className="scrollable tl-scroll">
              {this.state.isSearching ? (
                <div class="empty-view">
                  <Loader
                    styles={{ width: "80px", margin: "auto" }}
                    root={{ display: "flex" }}
                  />
                </div>
              ) : (
                <div>
                  {this.state.isSearching && !this.state.filteredSkills.length ? (
                    <div>
                      <EmptyLoader
                        style={{ width: "30%" }}
                        message="No Result found"
                      />
                      <p style={{ textAlign: "center" }}>No Result found</p>
                    </div>
                  ) : (
                    <>
                      <div id="scrollableDiv" className="scrollable tl-scroll">
                        {this.state.isSearching ? (
                          <Loader
                            styles={{ width: "80px", margin: "auto" }}
                            root={{ display: "flex" }}
                          />
                        ) : (
                          <div>
                            {this.state.isSearching === false && !this.state.filteredSkills.length ? (
                              <div>
                                <EmptyLoader
                                  style={{ width: "30%" }}
                                  message="No Results found"
                                />
                              </div>
                            ) : (
                              <div>
                                {this.state.filteredSkills
                                  .map((item, key) => (
                                    <DraftItem
                                      color={getColors(item.SKILL_NAME)}
                                      key={key}
                                      skill={item}
                                      {...this.props}
                                      deleteDraftSkill={this.deleteDraftSkill}
                                    />
                                  ))}
                                <div className="template-flex">
                                  <div className="template-box scrollable">
                                    <Pagination
                                      current={importPage}
                                      pageSize={9}
                                      total={this.props.searchFilteredCount}
                                      onChange={this.handleImportPageChange}
                                      hideOnSinglePage={false}
                                      showSizeChanger={false}
                                    />
                                  </div>
                                </div>
                              </div>
                            )}
                          </div>
                        )}
                      </div>
                    </>
                  )}
                </div>
              )}
            </div>
          </div> ) : template === "UserOnboarding" ? (
            <div className="task-col">
            <div className="title-btn">
              <h1 className="title">Search Results</h1>
            </div>
            <div id="scrollableDiv" className="scrollable tl-scroll">
              {this.state.isSearching ? (
                <div class="empty-view">
                  <Loader
                    styles={{ width: "80px", margin: "auto" }}
                    root={{ display: "flex" }}
                  />
                </div>
              ) : (
                <div>
                  {this.state.isSearching && !this.state.filteredSkills.length ? (
                    <div>
                      <EmptyLoader
                        style={{ width: "30%" }}
                        message="No Result found"
                      />
                      <p style={{ textAlign: "center" }}>No Result found</p>
                    </div>
                  ) : (
                    <>
                      <div id="scrollableDiv" className="scrollable tl-scroll">
                        {this.state.isSearching ? (
                          <Loader
                            styles={{ width: "80px", margin: "auto" }}
                            root={{ display: "flex" }}
                          />
                        ) : (
                          <div>
                            {this.state.isSearching === false && !this.state.filteredSkills.length ? (
                              <div>
                                <EmptyLoader
                                  style={{ width: "30%" }}
                                  message="No Results found"
                                />
                              </div>
                            ) : (
                              <div>
                                {this.state.filteredSkills
                                  .map((item, key) => (
                                    <DraftItem
                                      color={getColors(item.SKILL_NAME)}
                                      key={key}
                                      skill={item}
                                      {...this.props}
                                      deleteDraftSkill={this.deleteDraftSkill}
                                    />
                                  ))}
                                <div className="template-flex">
                                  <div className="template-box scrollable">
                                    <Pagination
                                      current={userOnPage}
                                      pageSize={9}
                                      total={this.props.searchFilteredCount}
                                      onChange={this.handleUserOnPageChange}
                                      hideOnSinglePage={false}
                                      showSizeChanger={false}
                                    />
                                  </div>
                                </div>
                              </div>
                            )}
                          </div>
                        )}
                      </div>
                    </>
                  )}
                </div>
              )}
            </div>
          </div> ) : template === "Desktop Walkthrough" ? (
            <div className="task-col">
            <div className="title-btn">
              <h1 className="title">Search Results</h1>
            </div>
            <div id="scrollableDiv" className="scrollable tl-scroll">
              {this.state.isSearching ? (
                <div class="empty-view">
                  <Loader
                    styles={{ width: "80px", margin: "auto" }}
                    root={{ display: "flex" }}
                  />
                </div>
              ) : (
                <div>
                  {this.state.isSearching && !this.state.filteredSkills.length ? (
                    <div>
                      <EmptyLoader
                        style={{ width: "30%" }}
                        message="No Result found"
                      />
                      <p style={{ textAlign: "center" }}>No Result found</p>
                    </div>
                  ) : (
                    <>
                      <div id="scrollableDiv" className="scrollable tl-scroll">
                        {this.state.isSearching ? (
                          <Loader
                            styles={{ width: "80px", margin: "auto" }}
                            root={{ display: "flex" }}
                          />
                        ) : (
                          <div>
                            {this.state.isSearching === false && !this.state.filteredSkills.length ? (
                              <div>
                                <EmptyLoader
                                  style={{ width: "30%" }}
                                  message="No Results found"
                                />
                              </div>
                            ) : (
                              <div>
                                {this.state.filteredSkills
                                  .map((item, key) => (
                                    <DraftItem
                                      color={getColors(item.SKILL_NAME)}
                                      key={key}
                                      skill={item}
                                      {...this.props}
                                      deleteDraftSkill={this.deleteDraftSkill}
                                    />
                                  ))}
                                <div className="template-flex">
                                  <div className="template-box scrollable">
                                    <Pagination
                                      current={desktopPage}
                                      pageSize={9}
                                      total={this.props.searchFilteredCount}
                                      onChange={this.handleDesktopPageChange}
                                      hideOnSinglePage={false}
                                      showSizeChanger={false}
                                    />
                                  </div>
                                </div>
                              </div>
                            )}
                          </div>
                        )}
                      </div>
                    </>
                  )}
                </div>
              )}
            </div>
          </div> ) : isActive === "CreatedBy Me" ? (
            <div className="task-col">
            <div className="title-btn">
              <h1 className="title">Search Results</h1>
            </div>
            <div id="scrollableDiv" className="scrollable tl-scroll">
              {this.state.isSearching ? (
                <div class="empty-view">
                  <Loader
                    styles={{ width: "80px", margin: "auto" }}
                    root={{ display: "flex" }}
                  />
                </div>
              ) : (
                <div>
                  {this.state.isSearching && !this.state.skills.length ? (
                    <div>
                      <EmptyLoader
                        style={{ width: "30%" }}
                        message="No Result found"
                      />
                      <p style={{ textAlign: "center" }}>No Result found</p>
                    </div>
                  ) : (
                    <>
                      <div id="scrollableDiv" className="scrollable tl-scroll">
                        {this.state.isSearching ? (
                          <Loader
                            styles={{ width: "80px", margin: "auto" }}
                            root={{ display: "flex" }}
                          />
                        ) : (
                          <div>
                            {this.state.isSearching === false && !this.state.skills.length ? (
                              <div>
                                <EmptyLoader
                                  style={{ width: "30%" }}
                                  message="No Results found"
                                />
                              </div>
                            ) : (
                              <div>
                                {this.state.skills
                                  .map((item, key) => (
                                    <DraftItem
                                      color={getColors(item.SKILL_NAME)}
                                      key={key}
                                      skill={item}
                                      {...this.props}
                                      deleteDraftSkill={this.deleteDraftSkill}
                                    />
                                  ))}
                                <div className="template-flex">
                                  <div className="template-box scrollable">
                                    <Pagination
                                      current={userPage}
                                      pageSize={9}
                                      total={this.props.searchCount}
                                      onChange={this.handleUserPageChange}
                                      hideOnSinglePage={false}
                                      showSizeChanger={false}
                                    />
                                  </div>
                                </div>
                              </div>
                            )}
                          </div>
                        )}
                      </div>
                    </>
                  )}
                </div>
              )}
            </div>
          </div> ) : 
          <div className="task-col">
            <div className="title-btn">
              <h1 className="title">Search Results</h1>
            </div>
            <div id="scrollableDiv" className="scrollable tl-scroll">
              {this.state.isSearching ? (
                <div class="empty-view">
                  <Loader
                    styles={{ width: "80px", margin: "auto" }}
                    root={{ display: "flex" }}
                  />
                </div>
              ) : (
                <div>
                  {this.state.isSearching && !this.state.skills.length ? (
                    <div>
                      <EmptyLoader
                        style={{ width: "30%" }}
                        message="No Result found"
                      />
                      <p style={{ textAlign: "center" }}>No Result found</p>
                    </div>
                  ) : (
                    <>
                      <div id="scrollableDiv" className="scrollable tl-scroll">
                        {this.state.isSearching ? (
                          <Loader
                            styles={{ width: "80px", margin: "auto" }}
                            root={{ display: "flex" }}
                          />
                        ) : (
                          <div>
                            {this.state.isSearching === false && !this.state.skills.length ? (
                              <div>
                                <EmptyLoader
                                  style={{ width: "30%" }}
                                  message="No Results found"
                                />
                              </div>
                            ) : (
                              <div>
                                {this.state.skills
                                  .map((item, key) => (
                                    <DraftItem
                                      color={getColors(item.SKILL_NAME)}
                                      key={key}
                                      skill={item}
                                      {...this.props}
                                      deleteDraftSkill={this.deleteDraftSkill}
                                    />
                                  ))}
                                <div className="template-flex">
                                  <div className="template-box scrollable">
                                    <Pagination
                                      current={AllPage}
                                      pageSize={9}
                                      total={this.props.searchCount}
                                      onChange={this.handlePageChange}
                                      hideOnSinglePage={false}
                                      showSizeChanger={false}
                                    />
                                  </div>
                                </div>
                              </div>
                            )}
                          </div>
                        )}
                      </div>
                    </>
                  )}
                </div>
              )}
            </div>
          </div>}
        </div>
      </React.Fragment>
    );
  }
}
const mapStateToProps = (state) => ({
  skills: state.skillReducer,
  skillReducer: state.skillReducer,
  userReducer: state.userReducer,
  searchTerm: state.searchTerm,
  searchCount: state.skillReducer.searchCount,
  isActive: state.skillReducer.isActive,
  searchFilteredCount: state.skillReducer.searchFilteredCount,
});

export default compose(
  withRouter,
  connect(mapStateToProps, {
    searchDraft,
    notify,
    deleteDraftSkill,
    changeActiveTab,
    searchSkillsByTemplate
  })
)(SearchResults);
